module.exports = __webpack_public_path__ + "static/media/help.6814c7d3.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/help.svg
// module id = 1725
// module chunks = 0